export default __webpack_public_path__ + "static/process-header-dd905b3dd0e0a98c7278d8accbf655f7.svg";